import React from "react";

export default function Footer() {
	return (
		<footer>
			<p className="copy">© Jakub Kacálek 2023</p>
		</footer>
	);
}
